module.exports = "/images/gd.svg?f3e11292dd6a4f6c67debe8e7efcc5a9";